// utils.js

import { circuitRequiredFields } from "./Constants/requiredFields";

export const formControlProps = (
  field,
  value,
  structureId,
  circuitGmId,
  requiredFields
) => {
  return {
    name: field,
    value: value || "",
    style: {
      width: "100%",
      borderColor: requiredFields?.[structureId]?.[circuitGmId]?.includes(field)
        ? "red"
        : "#ccc",
    },
  };
};

export const datePickerControlProps = (field, value) => ({
  name: field,
  value: value || "",
  style: { width: "100%" },
});

export const currencyControlProps = (field, value) => ({
  name: field,
  value: value || "",
  style: { width: "100%" },
});

export const getInputStyle = (baseStyle, field, value, requiredFields = []) => {
  return {
    ...baseStyle,
    borderColor: requiredFields?.includes(field) && !value ? "red" : "#ccc",
  };
};

export const handleCarrierInfoClick = (carrier) => {
  if (!carrier) {
    alert("No carrier info available.");
    return;
  }
  alert(`Carrier Info: ${carrier.carrierName || carrier}`);
};

export const formatDate = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp * 1000); // convert seconds to ms
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatNumber = (value) => {
  if (value == null) return;
  let numericValue = value.replace(/[^0-9.]/g, "");
  const parts = numericValue.split(".");
  let wholePart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  let decimalPart = parts[1] !== undefined ? `.${parts[1].slice(0, 2)}` : "";
  return wholePart + decimalPart;
};

export const truncateText = (text, maxLength = 100) => {
  if (!text) return "";
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};

export const getNestedValue = (obj, path, defaultValue = undefined) => {
  return path.reduce(
    (acc, key) => (acc && acc[key] !== undefined ? acc[key] : defaultValue),
    obj
  );
};

export const sortCircuits = (circuits = []) => {
  const statusOrder = {
    Active: 1,
    WIP: 2,
    null: 98,
    Decom: 99,
  };

  return [...circuits].sort((a, b) => {
    if (a.isNew && !b.isNew) return -1;
    if (!a.isNew && b.isNew) return 1;

    const orderA = statusOrder[a.status ?? null] ?? 50;
    const orderB = statusOrder[b.status ?? null] ?? 50;

    if (orderA !== orderB) {
      return orderA - orderB;
    }

    return Number(b.circuitGmId) - Number(a.circuitGmId);
  });
};

export const validateCircuits = ({ selectedSite, circuitUpdates }) => {
  const errors = [];

  selectedSite.structures.forEach((structure) => {
    structure.circuits.forEach((circuit) => {
      const isNew = circuit.isNew;
      const isUpdated =
        circuitUpdates?.[structure.structureId]?.[circuit.circuitGmId];

      if (!isNew && !isUpdated) return;

      const { isValid, missingFields } = validateCircuitRequiredFields(
        circuit,
        circuitRequiredFields
      );

      if (!isValid) {
        errors.push({
          structureId: structure.structureId,
          circuitGmId: circuit.circuitGmId,
          missingFields,
        });
      }
    });
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
};

export const validateCircuitRequiredFields = (circuit, requiredFields = []) => {
  const missing = requiredFields.filter((field) => isEmpty(circuit[field]));

  return {
    isValid: missing.length === 0,
    missingFields: missing,
  };
};

const isEmpty = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (typeof value === "object") return Object.keys(value).length === 0;
  return false;
};
